// IZ Lambdas answer their first calls after a cold start with this 500 until their Mongo
// connection is up. Only that error is retried; every other failure surfaces at once.

import { normalizeError } from './errors.ts';

const COLD_START_MESSAGE = 'before initial connection is complete';

export const COLD_START_ATTEMPTS = 3;
const COLD_START_DELAY_MS = 400;

// the exam stack serializes the same Mongoose error as `{}`, so its cold-start 500 carries no message
function isEmptyBody(data: unknown): boolean {
  return Boolean(data) && typeof data === 'object' && !Array.isArray(data) && Object.keys(data as object).length === 0;
}

export function isColdStartError(error: unknown): boolean {
  const normalized = normalizeError(error);
  if (normalized.kind !== 'server') return false;
  return normalized.message.indexOf(COLD_START_MESSAGE) >= 0 || (normalized.status === 500 && isEmptyBody(normalized.data));
}

function wait(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/** Runs `call` up to COLD_START_ATTEMPTS times, backing off 400ms, 800ms between cold-start 500s. */
export async function retryColdStart<T>(call: () => Promise<T>, delayMs: number = COLD_START_DELAY_MS): Promise<T> {
  for (let attempt = 1; ; attempt += 1) {
    try {
      return await call();
    } catch (error) {
      if (attempt >= COLD_START_ATTEMPTS || !isColdStartError(error)) throw error;
      await wait(delayMs * attempt);
    }
  }
}
